import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { ACTIVATE_DMX_DEVICE_PRESET } from './actionTypes';
import { activateDmxDevicePresetSuccessful, activateDmxDevicePresetFailed } from './actions';

import { getDmxAPI } from '../../../api/dmx';

const dmxAPI = getDmxAPI();

function* activateDevicePreset({ payload: { preset } }) {
  try {
    const response = yield call(dmxAPI.activateDevicePreset, preset.token, preset.deviceId, preset.id);
    if (response.message) {
      yield put(activateDmxDevicePresetSuccessful(response.message));
    } else throw response.error;
  } catch (error) {
    yield put(activateDmxDevicePresetFailed(error));
  }
}

export function* watchActivateDmxDevicePreset() {
  yield takeEvery(ACTIVATE_DMX_DEVICE_PRESET, activateDevicePreset);
}

function* activateDmxDevicePresetSaga() {
  yield all([fork(watchActivateDmxDevicePreset)]);
}

export default activateDmxDevicePresetSaga;
